import { useId } from 'react';
import { TextBlock } from '../../Atoms/Text';

export interface LabelledRadioGroupProps<T extends string | number> {
  label: string;
  name: string;
  options: { label: string; value: T }[];
  value: T;
  disabled: boolean;
  onChange: (value: T) => void;
}

/** A labelled row of radio buttons; the caller supplies the label and options. */
export const LabelledRadioGroup = <T extends string | number>({
  label,
  name,
  options,
  value,
  disabled,
  onChange
}: LabelledRadioGroupProps<T>) => {
  const labelId = useId();
  return (
    <>
      <TextBlock
        id={labelId}
        size="xs"
        weight="medium"
        color="grey6"
        className="mb-1">
        {label}
      </TextBlock>
      <div
        className="flex flex-wrap gap-3"
        role="radiogroup"
        aria-labelledby={labelId}>
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center gap-1 cursor-pointer text-sm">
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={option.value === value}
              disabled={disabled}
              onChange={() => onChange(option.value)}
              className="accent-indigo"
            />
            {option.label}
          </label>
        ))}
      </div>
    </>
  );
};
